import React, { useState, useEffect } from "react";
import _ from "lodash";
import moment from "moment";
import DayPicker from "react-day-picker";
import "react-day-picker/lib/style.css";
import { DateType } from "./index";
import { MonthPicker } from "./MonthPicker";

export const MonthDateModal = ({
  date,
  hideDatePicker,
  onCancel,
  updateDate
}: {
  date: DateType;
  hideDatePicker: () => void;
  onCancel: () => void;
  updateDate: (date: DateType) => void;
}) => {
  const [month, setMonth] = useState(date.month);
  const [day, setDay] = useState(date.day);
  const [year, setYear] = useState(date.year);

  useEffect(() => {
    document.getElementsByTagName("body")[0].classList.add("modal-open");
    return () => {
      document.getElementsByTagName("body")[0].classList.remove("modal-open");
    };
  }, []);

  return (
    <div>
      <div
        className="modal fade in geo-modal geo-modal--small geo-modal--show geo-modal--scroll geo-modal--date"
        id="month-pop"
        role="dialog"
      >
        <div className="modal-dialog month-pop-content">
          
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={() => {
                  hideDatePicker();
                  onCancel();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <ul className="nav nav-tabs">
                <li className={!date.day ? "active" : ""}>
                  <a href="#tab-mmonth" data-toggle="tab">
                    Month
                  </a>
                </li>
                <li className={date.day ? "active" : ""}>
                  <a href="#tab-mdate" data-toggle="tab">
                    Date
                  </a>
                </li>
              </ul>
              <div className="tab-content">
                <div
                  className={
                    !date.day ? "tab-pane fade active in" : "tab-pane fade"
                  }
                  id="tab-mmonth"
                >
                  <MonthPicker
                    month={month}
                    year={year}
                    setMonth={(monthSelected: number) => {
                      setMonth(monthSelected);
                      setDay(null);
                    }}
                    setYear={setYear}
                  />
                </div>
                <div
                  className={date.day ? "tab-pane fade active in" : "tab-pane"}
                  id="tab-mdate"
                >
                  <DayPicker
                    selectedDays={
                      day
                        ? new Date(year, month, day)
                        : new Date(year, month, undefined)
                    }
                    onDayClick={(dateSelected, { selected }) => {
                      if (selected) setDay(null);
                      else setDay(moment(dateSelected).date());
                      setMonth(moment(dateSelected).month());
                      setYear(moment(dateSelected).year());
                    }}
                    month={new Date(year, month)}
                    modifiersStyles={{
                      selected: {
                        backgroundColor: "#e1ecee",
                        color: "#30053f"
                      }
                    }}
                  />
                </div>
              </div>

              <div className="d-flex modal-inside-footer">
                <button
                  type="button"
                  className="geo-btn geo-btn--caps geo-btn--link geo-btn--noshade"
                  style={{ lineHeight: 1 }}
                  onClick={() => {
                    hideDatePicker();
                    onCancel();
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn secondary-btn"
                  onClick={() => {
                    updateDate({ day, month, year });
                    hideDatePicker();
                  }}
                >
                  Find Photos
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade in" />
    </div>
  );
};
